//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["edit_input", "fontSize"],
  data() {
    return {
      fileList: []
      // inputList: [
      // { v: "事业部", value: "朵拉事业部", no_arrow: true, read: true },
      // { v: "产品品牌", value: "朵拉",  read: true },
      // { v: "当前门店", value: "[S20023126]铜川新起点奶粉", no_arrow: true, read: true },
      // ],
    };
  },
  methods: {
    // take_tel(tel) {
    //   wx.makePhoneCall({
    //     phoneNumber: tel
    //   });
    // }
    chakan_click(index) {
      this.$emit("go_mingxi", index);
    },
    onClickItem(item) {
      if (item.action) {
        item.action();
      }
    }
  }
};
